import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { useTranslation } from 'react-i18next';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import BanquetNavbar from '../components/BanquetNavbar';


delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: iconRetina,
  iconUrl: icon,
  shadowUrl: iconShadow,
});

const locations = [
  {
    name: 'Fantasyland Forest Theatre',
    position: [35.6329, 139.8804],
    address: 'Tokyo Disneyland, Maihama, Urayasu, Chiba 279-0031, Japan',
    googleMapsLink: 'https://www.google.com/maps/dir/?api=1&destination=35.6329,139.8804'
  },
  {
    name: 'Tokyo Disney Resort',
    position: [35.6312, 139.8795],
    address: 'Tokyo Disneyland, Maihama, Urayasu, Chiba 279-0031, Japan',
    googleMapsLink: 'https://www.google.com/maps/dir/?api=1&destination=35.6312,139.8795'
  }
];

const MapPage = () => {
  const { t } = useTranslation();
 
  return (
    <div className="flex-1 flex flex-col">
      <div className="flex-none">
        <BanquetNavbar />
      </div>
      <div className="flex-1 flex items-center justify-center py-4">
        <div className="w-full max-w-6xl px-4 my-auto">
          <div className="bg-white rounded-lg shadow-xl p-4 mb-8">
          <h2 className="text-2xl font-bold text-beast-brown-800 mb-8 text-center">
            {t('sections.map.title')}
          </h2>
          <div className="">
            <MapContainer
              center={[35.6320, 139.8800]}
              zoom={16}
              style={{ height: '50vh', width: '100%', borderRadius: '0.5rem' }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              {locations.map((location, index) => (
                <Marker
                  key={index}
                  position={location.position}
                >
                  <Popup>
                    <div className="text-center p-2">
                      <h3 className="font-bold text-lg mb-2">{location.name}</h3>
                      <p className="text-sm text-beast-brown-700 mb-4">{location.address}</p>
                      <a
                        href={location.googleMapsLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-belle-blue-600 hover:bg-belle-blue-700 px-4 py-2 rounded-lg transition-colors inline-block font-medium shadow-md hover:shadow-lg"
                        style={{ color: '#ffffff' }}
                      >
                        {t('sections.map.viewRoute')}
                      </a>
                    </div>
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapPage; 